export default {
    height: 60,
    padding: 1.5,
    bottom: 2,
};
